<template>
    <ViewProfesseur/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewProfesseur from "@/components/Professeur/ViewProfesseur.vue";

    export default defineComponent({
      name: "ViewProfesseurPage",
      components: {
        
        ViewProfesseur,
      },
    });
  </script>